/** 
 *  计算属性
**/
const Getters = {

}

export default Getters